<template>
    <div
        class="header_div">
        <div class="header_logo" @click="backHome">
            <img
                :class="province_logo ? 'logo' : 'logo_province'"
                :src="province_logo ? '../static/img/datalogo.png' : '../static/img/header_logo_province.png'" />
            <span :class="province_logo ? 'title' : 'title_province'">数据大脑</span>
        </div>
        <div class="header_searchbox">
            <el-input v-model="keyWords" @keyup.enter.native='search' class="input-with-select" size='medium'>
                <el-select v-model="value" slot="prepend" placeholder="请选择">
                    <el-option
                        v-for="item in type"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
			    </el-select>
                <i slot="suffix"
                    class="el-input_icon"
                    @click="search">
                    <img src="../static/img/search-icon.png" alt="" class="input-search-icon">
			    </i>
            </el-input>
        </div>
    </div>
</template>

<script>
export default {
name:'header_Search',
props:{
    index:{
        type:String,
        default:''
    },
    values:{
        type:String,
        default:'1'
    }
},
data(){
    return{
        keyWords:this.index,
        select:'',
        type: [{
				value: '1',
				label: '文章'
			}, {
				value: '2',
				label: '媒体'
			}, {
				value: '3',
				label: '编辑记者'
			}, {
				value: '4',
				label: '内容人名'
			}, {
				value: '5',
				label: '内容机构'
        },{
				value: '6',
				label: '内容地点'
        }],
        value:this.values,
        address: ''
    }
},
computed: {
province_logo () {
    return this.address !== '贵州省'
}
},
created(){
    var storage = window.localStorage
    this.address = storage.getItem('address')
},
methods:{
    search(){
        this.$emit("searchNewWord",this.keyWords,this.value)
    },
    backHome(){
        let storage = window.localStorage
        this.$router.push({
            path:'/',
            query:{
                address: storage.getItem('address')
            }
        })
    }
}
}
</script>


<style>
.header_div{
    width: 100%;
    min-width: 1200px;
    height: 70px;
    color: #fff;
    display: flex;
    align-items: center;
    font-family:思源黑体;
    font-weight:bold;
    color:rgba(255,255,255,1);
    background-image: url('../static/img/index-back-pro.png');
    background-size:100% 100%; 
}
.header_div .header_logo{
    display: flex;
    width:20%;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}
.header_div .header_logo .logo{
    width: 40px;
    height: 40px;
}
.header_div .header_logo .logo_province {
    width: 130px;
    height: 56px;
}
.header_div .header_logo .title{
    margin-left: 12px;
    font-size: 18px;
}
.header_div .header_logo .title_province {
    font-size: 18px;
    color:rgba(107,250,245,1);
}
.header_div .header_searchbox{
    width : 40%;
    display: flex;
    margin-left : 8%;
    opacity: 0.8;
    box-shadow: 1px 0px 1px 0px rgba(0,169,222,0.2), 0px 1px 1px 0px rgba(101,82,255,1);
    border-radius: 0px 3px 3px 0px;
}
/* .header_div .el-input-group {
    box-shadow: 0px 1px 1px 0px rgba(52,42,128,1);
    opacity: 0.8;
} */
.header_div .el-input-group__prepend {
    border-right: 0;
    border: 0px;
    background: rgb(0,0,0,0);
}
.header_div .el-select{
    width: 110px;
    border-radius: 4px  0  0 4px;
    color:#fff;
    background-color: #00C2FF;
}
.header_div .input-with-select .input-search-icon {
    width: 16px;
    height: 16px;
    margin-top: 10px;
    margin-right: 5px;
}
.header_div .el-icon-arrow-up:before {
    content: "\E60C";
    color:#fff
}
.header_div .el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
    border-color: transparent;
    background-color: transparent;
    color: inherit;
    border-top: 0;
    border-bottom: 0;
    width: 80px;
    margin-left: 0px;
    text-align: center;
}
.header_div .el-input--suffix .el-input__inner {
    padding-right: 0px;
}
.header_div .el-input_icon{
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/headerSearch.vue